module.exports = __webpack_public_path__ + "img/icon-question-rating-star.63fbc606.svg";